<template>
<div id="nested-form" class="scfForm">
<div v-html="translationHelper.getTranslation('vdi_not_available')"></div>
</div>
</template>
<script>
	export default{
		props: ["translationHelper"]
	}
</script>